/* eslint-disable */
import React from 'react';
import classNames from 'classnames';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactTooltip from 'react-bootstrap/Tooltip';

import './Tooltip.scss';

const renderTooltip = (label, customClass, props) => (
	<ReactTooltip
		bsClass="tooltip-component--overlay"
		className={classNames('tooltip-component--overlay', customClass)}
		id="tooltip-component--overlay"
		// eslint-disable-next-line react/jsx-props-no-spreading
		{...props}
	>
		{label}
	</ReactTooltip>
);

const Tooltip = ({ children, className, label, placement = 'auto', show = 100, hide = 400, customClass }) => {
	return (
		<OverlayTrigger
			className="tooltip-component"
			placement={placement}
			delay={{ show, hide }}
			overlay={(props) => renderTooltip(label, customClass, props)}
		>
			<div className={className}>{children}</div>
		</OverlayTrigger>
	);
};

export default Tooltip;
